import { firebaseDb, firebaseFn } from "../../firebase";
import { arrayMove } from "../../utils/common";
import { GET_FILE_SUCCESS } from "../files/actions";

export const GET_CHECKLISTS_REQUEST = "GET_CHECKLISTS_REQUEST";
export const GET_CHECKLISTS_SUCCESS = "GET_CHECKLISTS_SUCCESS";
export const GET_CHECKLISTS_FAILURE = "GET_CHECKLISTS_FAILURE";

export const GET_FIRST_CHECKLISTS_REQUEST = "GET_FIRST_CHECKLISTS_REQUEST";
export const GET_FIRST_CHECKLISTS_SUCCESS = "GET_FIRST_CHECKLISTS_SUCCESS";
export const GET_FIRST_CHECKLISTS_FAILURE = "GET_FIRST_CHECKLISTS_FAILURE";

export const ADD_CHECKLIST_REQUEST = "ADD_CHECKLIST_REQUEST";
export const ADD_CHECKLIST_SUCCESS = "ADD_CHECKLIST_SUCCESS";
export const ADD_CHECKLIST_FAILURE = "ADD_CHECKLIST_FAILURE";

export const EDIT_CHECKLIST_REQUEST = "EDIT_CHECKLIST_REQUEST";
export const EDIT_CHECKLIST_SUCCESS = "EDIT_CHECKLIST_SUCCESS";
export const EDIT_CHECKLIST_FAILURE = "EDIT_CHECKLIST_FAILURE";

export const ADD_CHECKLIST_ITEM_REQUEST = "ADD_CHECKLIST_ITEM_REQUEST";
export const ADD_CHECKLIST_ITEM_SUCCESS = "ADD_CHECKLIST_ITEM_SUCCESS";
export const ADD_CHECKLIST_ITEM_FAILURE = "ADD_CHECKLIST_ITEM_FAILURE";

export const EDIT_CHECKLIST_ITEM_REQUEST = "EDIT_CHECKLIST_ITEM_REQUEST";
export const EDIT_CHECKLIST_ITEM_SUCCESS = "EDIT_CHECKLIST_ITEM_SUCCESS";
export const EDIT_CHECKLIST_ITEM_FAILURE = "EDIT_CHECKLIST_ITEM_FAILURE";

export const DELETE_CHECKLIST_ITEM_REQUEST = "DELETE_CHECKLIST_ITEM_REQUEST";
export const DELETE_CHECKLIST_ITEM_SUCCESS = "DELETE_CHECKLIST_ITEM_SUCCESS";
export const DELETE_CHECKLIST_ITEM_FAILURE = "DELETE_CHECKLIST_ITEM_FAILURE";

export const UPLOAD_CHECKLIST_REQUEST = "UPLOAD_CHECKLIST_REQUEST";
export const UPLOAD_CHECKLIST_SUCCESS = "UPLOAD_CHECKLIST_SUCCESS";
export const UPLOAD_CHECKLIST_FAILURE = "UPLOAD_CHECKLIST_FAILURE";

export const SET_PROJECT_ID = "SET_PROJECT_ID";

export const IMPORT_FIELD_NAMES = {
  description: 'Item Description',
  section: 'Item Section',
  standard: 'Item Standart',
  must: 'Item Must',
  checklistGroup: 'List Group',
  checklistTitle: 'List Title',
  checklistLogoUrl: 'List Logo'
};

const USER_CHECKLISTS_PATH = '/user-checklists';
const PROJECT_CHECKLISTS_PATH = '/project-checklists';

function getChecklistPath({getState, userId}) {
  const { selectedProjectId } = getState().checklists;
  let path = `${USER_CHECKLISTS_PATH}/${userId}`;

  if (selectedProjectId && selectedProjectId !== 'PRIVATE') {
    path = `${PROJECT_CHECKLISTS_PATH}/${selectedProjectId}`;
  }

  return path;
}

export const getChecklist = (userId, isFirst = false) => (dispatch, getState) => {
  try {
    !isFirst && dispatch({ type: GET_CHECKLISTS_REQUEST });
    const path = getChecklistPath({ getState, userId });

    firebaseDb.ref(path).once("value", snapshot => {
      dispatch({ type: GET_CHECKLISTS_SUCCESS, payload: snapshot.val() });
    });

  } catch (e) {
    !isFirst && dispatch({ type: GET_CHECKLISTS_FAILURE });
  }
};

export const firstChecklist = userId => async dispatch => {
  try {
    dispatch({ type: GET_FIRST_CHECKLISTS_REQUEST });
    await dispatch(getChecklist(userId, true));
    dispatch({ type: GET_FIRST_CHECKLISTS_SUCCESS });
  } catch (e) {
    dispatch({ type: GET_FIRST_CHECKLISTS_FAILURE });
  }
};

export const addChecklist = (userId, checklist) => async (dispatch, getState) => {
  let updates = {};
  const path = getChecklistPath({ getState, userId });

  const list = await firebaseDb.ref(`${path}/lists`).push();

  if (!checklist.logoUrl) {
    checklist.logoUrl = '';
  }

  updates[`${path}/lists/${list.key}`] = { ...checklist, id: list.key};

  await firebaseDb
    .ref(`${path}/order`)
    .once("value", snapshot => {
      if (!snapshot.val()) {
        updates[`${path}/order/0`] = list.key;
      } else {
        const index = Object.keys(snapshot.val()).length;
        updates[`${path}/order/${index}`] = list.key;
      }
    });

  await firebaseDb.ref().update(updates);
};

export const addChecklistItem = (
  userId,
  checklistId,
  data
) => async (dispatch, getState) => {
  let updates = {};
  let copyData = { ...data };

  const path = getChecklistPath({ getState, userId });

  const item = await firebaseDb
    .ref(`${path}/lists/${checklistId}/items`)
    .push();
  copyData.id = item.key;

  updates[
    `${path}/lists/${checklistId}/items/${copyData.id}`
  ] = copyData;

  await firebaseDb
    .ref(`${path}/lists/${checklistId}/order`)
    .once("value", snapshot => {
      if (!snapshot.val()) {
        updates[`${path}/lists/${checklistId}/order/0`] =
          copyData.id;
      } else {
        const index = Object.keys(snapshot.val()).length;
        updates[
          `${path}/lists/${checklistId}/order/${index}`
        ] = copyData.id;
      }
    });
  await firebaseDb.ref().update(updates);
};

export const editChecklistItem = (
  userId,
  checklistId,
  data
) => async (dispatch, getState) => {
  let copyData = { ...data };
  let updates = {};
  const path = getChecklistPath({ getState, userId });

  if (!copyData.standardUrl) {
    copyData.standardUrl = '';
  }

  if (!copyData.isPhotoRequired) {
    copyData.isPhotoRequired = false;
  }

  if (!copyData.isCommentRequired) {
    copyData.isCommentRequired = false;
  }

  updates[
    `${path}/lists/${checklistId}/items/${copyData.id}`
  ] = copyData;
  await firebaseDb.ref().update(updates);
};

export const deleteChecklistItem = (
  userId,
  checklistId,
  itemId
) => async (dispatch, getState) => {
  let updates = {};
  let orderArr = [];
  const path = getChecklistPath({ getState, userId });

  await firebaseDb
    .ref(`${path}/lists/${checklistId}/items/${itemId}`)
    .remove(() => {
      dispatch({ type: DELETE_CHECKLIST_ITEM_FAILURE });
    });

  await firebaseDb
    .ref(`${path}/lists/${checklistId}/order`)
    .once("value", snapshot => {
      let order = snapshot.val();

      orderArr = Object.values(order).filter(id => id !== itemId);
    });
  await firebaseDb
    .ref(`${path}/lists/${checklistId}/order`)
    .remove();
  await firebaseDb
    .ref(`${path}/lists/${checklistId}/order`)
    .set({ ...orderArr });
  await firebaseDb.ref().update(updates);
};

export const editChecklist = (userId, checklistId, { title, text, logoUrl, group }) => async (dispatch, getState) => {
  const updates = {};
  const path = getChecklistPath({ getState, userId });

  if (title) updates[`${path}/lists/${checklistId}/title`] = title;
  if (group) updates[`${path}/lists/${checklistId}/group`] = group;
  if (text) updates[`${path}/lists/${checklistId}/text`] = text;

  if (logoUrl) updates[`${path}/lists/${checklistId}/logoUrl`] = logoUrl;
  if (logoUrl === '') updates[`${path}/lists/${checklistId}/logoUrl`] = '';

  await firebaseDb.ref().update(updates);
};

export const moveChecklist = (userId, oldIndex, newIndex) => async (dispatch, getState) => {
  let updates = {};
  const path = getChecklistPath({ getState, userId });

  await firebaseDb
    .ref(`${path}/order`)
    .once("value", snapshot => {
      let order = snapshot.val();
      const orderArr = Object.values(order);
      const movedOrder = arrayMove(orderArr, oldIndex, newIndex);
      movedOrder.forEach((item, index) => {
        updates[`${path}/order/${index}`] = item;
      });
    });
  await firebaseDb.ref().update(updates);
};

export const insertAtIndex = (({selectedTaskIds, columns, source, destination}) => {
  const start = columns[source.droppableId];
  const dragged = start.order[source.index];

  const destinationIndexOffset = selectedTaskIds.reduce(
      (previous, current) => {
        if (current === dragged) {
          return previous;
        }

        const final = columns[destination.droppableId];
        const column = columns[destination.droppableId];

        if (column !== final) {
          return previous;
        }

        const index = column.order.indexOf(current);

        if (index >= destination.index) {
          return previous;
        }

        // the selected item is before the destination index
        // we need to account for this when inserting into the new location
        return previous + 1;
      },
      0,
  );

  const result = destination.index - destinationIndexOffset;
  return result;
});

export const moveChecklistItemInParent = (
  userId,
  checklistId,
  oldIndex,
  newIndex,
  selectedTaskIds
) => async (dispatch, getState) => {
  let updates = {};
  const path = getChecklistPath({ getState, userId });

  await firebaseDb
    .ref(`${path}/lists/${checklistId}/order`)
    .once("value", snapshot => {
      let order = snapshot.val();
      let movedOrder = Object.values(order);

      const remainingTaskIds = movedOrder.filter(
          (id) => !selectedTaskIds.includes(id),
      );

      remainingTaskIds.splice(newIndex, 0, ...selectedTaskIds);


      remainingTaskIds.forEach((item, index) => {
        updates[
          `${path}/lists/${checklistId}/order/${index}`
        ] = item;
      });
    });

  await firebaseDb.ref().update(updates);
};

export const moveChecklistItemToOtherList = (
  userId,
  checklistIdOld,
  checklistIdNew,
  itemsData,
  newIndex
) => async (dispatch, getState) => {
  let updates = {};

  let data = [ ...itemsData ];

  const path = getChecklistPath({ getState, userId });


  const newIds = [];
  data.forEach(clItem => {
    clItem.id = firebaseDb.ref(`${path}/lists/${checklistIdNew}/items`).push().key;
    newIds.push(clItem.id);

    updates[`${path}/lists/${checklistIdNew}/items/${clItem.id}`] = clItem;
  })

  await firebaseDb
    .ref(`${path}/lists/${checklistIdNew}/order`)
    .once("value", snapshot => {
      let order = snapshot.val();

      if (order) {
        const orderArr = Object.values(order);
        orderArr.splice(newIndex, 0, ...newIds);

        orderArr.forEach((item, index) => {
          updates[
            `${path}/lists/${checklistIdNew}/order/${index}`
          ] = item;
        });
      } else {
        updates[`${path}/lists/${checklistIdNew}/order/`] = newIds
      }
    });

  await firebaseDb.ref().update(updates);
};

export const deleteChecklist = (userId, checklistId) => async (dispatch, getState) => {
  const path = getChecklistPath({ getState, userId });

  let orderArr = [];
  await firebaseDb
    .ref(`${path}/lists/${checklistId}`)
    .remove();

  await firebaseDb
    .ref(`${path}/order`)
    .once("value", snapshot => {
      let order = snapshot.val();

      orderArr = Object.values(order).filter(id => id !== checklistId);
    });
  await firebaseDb.ref(`${path}/order`).remove();
  await firebaseDb.ref(`${path}/order`).set({ ...orderArr });
};

export const copyChecklist = (userId, checklistId, index) => async (dispatch, getState) => {
  const path = getChecklistPath({ getState, userId });

  let newList = {};
  let updates = {};
  let oldList = {};

  await firebaseDb
    .ref(`${path}/lists/${checklistId}`)
    .once("value", snapshot => {
      oldList = snapshot.val();
    });

  const list = await firebaseDb.ref(`${path}/lists`).push();
  newList.id = list.key;
  newList.order = [];
  newList.items = {};

  if (Object.values(oldList.items).length > 0) {
    oldList.order.forEach(oldId => {
      const item = firebaseDb.ref(`${path}/lists/${newList.id}/items`).push();

      if (oldList.items[oldId]) {
        updates[`${path}/lists/${newList.id}/items/${item.key}`] = {...oldList.items[oldId], id: item.key};
        newList.order.push(item.key);
      }
    });
  }

  updates[`${path}/lists/${newList.id}/order`] = newList.order;
  updates[`${path}/lists/${newList.id}/id`] = newList.id;
  updates[`${path}/lists/${newList.id}/title`] = oldList.title + "_copy";

  if (oldList.logoUrl) {
    updates[`${path}/lists/${newList.id}/logoUrl`] = oldList.logoUrl;
  }

  if (oldList.text) {
    updates[`${path}/lists/${newList.id}/text`] = oldList.text;
  }

  if (oldList.group) {
    updates[`${path}/lists/${newList.id}/group`] = oldList.group;
  }

  await firebaseDb
    .ref(`${path}/order`)
    .once("value", snapshot => {
      let order = snapshot.val();
      const orderArr = Object.values(order);
      orderArr.splice(index + 1, 0, newList.id);
      orderArr.forEach((item, index) => {
        updates[`${path}/order/${index}`] = item;
      });
    });

  await firebaseDb
    .ref()
    .update(updates)
    .catch(err => console.log(err));
};

export const shareChecklist = ({userId, checklistIds, projectId}) => async (dispatch, getState) => {
  const { selectedProjectId } = getState().checklists;

  const shareChecklists = firebaseFn.httpsCallable('shareChecklists')
  try {

    shareChecklists({
      checklistIds,
      userId,
      projectIdTo: projectId,
      projectIdFrom: selectedProjectId
    }).then((result) => {
      console.log('result', result);
    })

  } catch (e) {
    console.error('ERROR', e);
  }
};

export const uploadChecklist = (userId, checklist) => async (dispatch, getState) => {
  let newList = {};
  let updates = {};
  let oldList = checklist;
  const path = getChecklistPath({ getState, userId });

  dispatch({
    type: UPLOAD_CHECKLIST_REQUEST
  });

  try {
    const list = await firebaseDb
      .ref(`${path}/lists`)
      .push();
    newList.id = list.key;
    newList.order = [];
    newList.items = {};

    let checklistTitle = '', checklistLogoUrl = '', checklistGroup = '';

    oldList.forEach((item) => {
      const itemId = firebaseDb.ref(`${path}/lists/${newList.id}/items`).push().key;

      let isMust = false;

      if (item[IMPORT_FIELD_NAMES.must]) {
        if (item[IMPORT_FIELD_NAMES.must] === 'true' || item[IMPORT_FIELD_NAMES.must] === 'TRUE') {
          isMust = true;
        }

        if (item[IMPORT_FIELD_NAMES.must] === 'false' || item[IMPORT_FIELD_NAMES.must] === 'FALSE') {
          isMust = false;
        }
      }

      newList.items[itemId] = {
        isMust: isMust,
        description: item[IMPORT_FIELD_NAMES.description] ? item[IMPORT_FIELD_NAMES.description] : '',
        section: item[IMPORT_FIELD_NAMES.section] ? item[IMPORT_FIELD_NAMES.section] : '',
        standard: item[IMPORT_FIELD_NAMES.standard] ? item[IMPORT_FIELD_NAMES.standard] : '',
        id: itemId
      };

      if (checklistTitle === '') {
        checklistTitle = item[IMPORT_FIELD_NAMES.checklistTitle] ? item[IMPORT_FIELD_NAMES.checklistTitle] : '';
      }
      if (checklistLogoUrl === '') {
        checklistLogoUrl = item[IMPORT_FIELD_NAMES.checklistLogoUrl] ? item[IMPORT_FIELD_NAMES.checklistLogoUrl] : '';
      }
      if (checklistGroup === '') {
        checklistGroup = item[IMPORT_FIELD_NAMES.checklistGroup] ? item[IMPORT_FIELD_NAMES.checklistGroup] : '';
      }

      newList.order.push(itemId);
    });

    updates[`${path}/lists/${newList.id}/id`] = newList.id;
    updates[`${path}/lists/${newList.id}/items`] = newList.items;
    updates[`${path}/lists/${newList.id}/title`] = checklistTitle;
    updates[`${path}/lists/${newList.id}/order`] = newList.order;
    updates[`${path}/lists/${newList.id}/logoUrl`] = checklistLogoUrl;
    updates[`${path}/lists/${newList.id}/group`] = checklistGroup;

    // return;
    await firebaseDb
      .ref(`${path}/order`)
      .once("value", snapshot => {
        let order = snapshot.val();
        const orderArr = Object.values(order || {});
        orderArr.unshift(newList.id);
        orderArr.forEach((item, index) => {
          updates[`${path}/order/${index}`] = item;
        });
      });

    await firebaseDb
      .ref()
      .update(updates)
      .catch(err => console.log(err));

    dispatch(getChecklist(userId));
  } catch (e) {
    console.log('error', e);
    dispatch({
      type: UPLOAD_CHECKLIST_FAILURE,
      payload: true
    });
    setTimeout(() => {
      dispatch({
        type: UPLOAD_CHECKLIST_FAILURE,
        payload: false
      });
    }, 3000);
  }
};

export const setProjectId = (projectId, isProjectOwner) => async dispatch => {
  dispatch({
    type: SET_PROJECT_ID,
    payload: {projectId, isProjectOwner}
  });
};
